module.exports = __webpack_public_path__ + "images/emoji/cookie.000bafc7d92fe1af442a.png";